import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import axios from '../../axios';
import config from '../../config';
import Footer from '../Footer/FooterWrapper';
import './Blog.css';
import { useLanguage } from '../../i18n/LanguageContext';

const BlogPost = () => {
  const { t } = useLanguage();
  const { postId } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const history = useHistory();
  const backend_url = config.backend_url.replace(/\/$/, '');

  useEffect(() => {
    const fetchPost = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${backend_url}/blog/posts/${postId}`, { withCredentials: true });
        if (response.data.success) {
          setPost(response.data.post);
        } else {
          setError('Failed to fetch blog post');
        }
      } catch (err) {
        console.error('Error fetching blog post:', err);
        setError('Failed to fetch blog post. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    if (postId) {
      fetchPost();
    }
  }, [postId, backend_url]);

  // Format date to readable format
  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('sv-SE', options);
  };

  if (loading) {
    return (
      <div className="blog-container">
        <div className="blog-header">
          <h1>{t('Laddar inlägg...')}</h1>
        </div>
      </div>
    );
  }

  if (error || !post) {
    return (
      <div className="blog-container">
        <div className="blog-header">
          <h1>{t('Inlägg hittades inte')}</h1>
          <p className="error-message">{t(error || 'Inlägget existerar inte eller har tagits bort.')}</p>
          <button 
            className="blog-back-link" 
            onClick={() => history.push('/blog')}
          >
            {t('Tillbaka till blogg')}
          </button>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="blog-container">
        <div className="blog-single-post">
          {post.image_filename && (
            <img 
              src={`${backend_url}/static/blog_images/${post.image_filename}`}
              alt={post.title} 
              className="blog-single-image" 
            />
          )}
          
          <h1 className="blog-single-title">{post.title}</h1>
          
          <div className="blog-single-metadata">
            <span className="blog-single-author">{t('Av:')} {post.author}</span>
            <span className="blog-single-date">{formatDate(post.created_at)}</span>
          </div>
          
          <div 
            className="blog-single-content"
            dangerouslySetInnerHTML={{ __html: post.content }}
          />
          
          <button 
            className="cta-button" 
            onClick={() => history.push('/blog')}
          >
            {t('Tillbaka till blogg')}
          </button>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default BlogPost;
